import { useSwipeable } from 'react-swipeable';
import { useNavigate } from 'react-router-dom';

const Main = ({ language }: { language: string }) => {
  const navigate = useNavigate();

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      navigate('/Sharing');
    },
    onSwipedRight: () => {
      navigate('/Entrees');
    },
    trackMouse: true,
    delta: 50,
    trackTouch: true
  });

  const renderMenuSection = (titleFr: string, titleEn: string, items: any[], subtitleFr?: string, subtitleEn?: string) => (
    <div className="bg-white/80 backdrop-blur-sm rounded-xl p-8 max-w-4xl w-full shadow-lg mt-8">
      <h2 className="text-3xl font-semibold mb-2 text-green-950 text-center border-b pb-2">
        {language === "fr" ? titleFr : titleEn}
      </h2>
      {subtitleFr && subtitleEn && (
        <p className="text-gray-600 mb-6 italic">
          {language === "fr" ? subtitleFr : subtitleEn}
        </p>
      )}
      <ul className="space-y-6">
        {items.map((item, index) => (
          <MenuListItem
            key={`${titleEn}-${index}`}
            fr={item.fr}
            en={item.en}
            prixFr={item.prixFr}
            prixEn={item.prixEn}
            descFr={item.descFr}
            descEn={item.descEn}
            language={language}
          />
        ))}
      </ul>
    </div>
  );

  return (
    <div
      {...handlers}
      className="min-h-screen flex flex-col items-center p-8 bg-cover bg-center bg-fixed pt-[110px]"
      style={{ backgroundImage: "url('/image/Lona2.jpg')" }}
    >
      <p className="text-center text-xs text-green-950 mt-2">
        {language === "fr" ? "Glissez pour naviguer" : "Swipe to navigate"}
      </p>

      {renderMenuSection("SALADES", "SALADS", [
        {
          fr: "Grec",
          en: "Greek",
          prixFr: "18$",
          prixEn: "$18",
          descFr: "Salade fraîche et colorée de tomates, concombres, poivrons, oignons, feta et olives Kalamata, le tout sublimé par une touche d'huile d'olive.",
          descEn: "Fresh and colorful salad with tomatoes, cucumbers, peppers, onions, feta, and Kalamata olives, all topped with a touch of olive oil."
        },
        {
          fr: "Endive",
          en: "Endive",
          prixFr: "19$",
          prixEn: "$19",
          descFr: "Salade d’endives garnie de poivrons grillés, quartiers d’orange, anchois, persil frais et pistaches, le tout relevé par une vinaigrette maison.",
          descEn: "Endive salad topped with grilled peppers, orange segments, anchovies, fresh parsley, and pistachios, finished with a homemade dressing."
        },
        {
          fr: "Salade de thon",
          en: "Tuna Salad",
          prixFr: "18$",
          prixEn: "$18",
          descFr: "Une salade fraîche avec du thon et des légumes croquants",
          descEn: "A fresh salad with tuna and crunchy vegetables"
        }
      ])}

      {renderMenuSection("SPÉCIALITÉS", "SPECIALTIES", [
        {
          fr: "Chakchouka",
          en: "Chakchouka",
          prixFr: "22$",
          prixEn: "$22",
          descFr: "2 œufs pochés cuits dans un savoureux mélange de tomates, poivrons, onions, servis avec nos délicieuses patates maison et accompagné du pain traditionnel maghrébin",
          descEn: "2 poached eggs cooked in a flavorful mix of tomatoes, peppers, and onions, served with our delicious homemade potatoes and accompanied by traditional Maghreb bread."
        },
        {
          fr: "Steak de choux-fleur",
          en: "Cauliflower Steak",
          prixFr: "22$",
          prixEn: "$22",
          descFr: "Tranche de choux-fleur Rôtie avec persil, ail, huile d'olive, servie sur un lit de purée de poivron cuit au charbon",
          descEn: "Roasted cauliflower steak with parsley, garlic, and olive oil, served on a bed of charcoal-grilled pepper purée."
        },
        {
          fr: "Tadjine de Sardines",
          en: "Sardine Tagine",
          prixFr: "➡️ Bientôt",
          prixEn: "➡️ Soon",
          descFr: "Boulettes de sardine cuites dans une riche sauce tomate et un mélange d'assaisonnement et accompagné du pain traditionnel maghrébin",
          descEn: "Sardine balls cooked in a rich tomato sauce with a blend of seasonings and accompanied by traditional Maghreb bread."
        },
        {
          fr: "Agneau BBQ",
          en: "BBQ Lamb",
          prixFr: "29$",
          prixEn: "$29",
          descFr: "Agneau cuit au charbon servi avec une somptueuse sauce aux champignon et pomme de terre, assaisonnée avec de fraiche herbes, ail et de jus de citron, servi avec nos patate maison.",
          descEn: "Charcoal-cooked lamb served with a sumptuous mushroom and potato sauce, seasoned with fresh herbs, garlic, and lemon juice, served with our homemade potatoes."
        }
      ])}

      {renderMenuSection("BÉNÉDICTINES", "BENEDICTINES", [
        {
          fr: "Espagnole",
          en: "Spanish",
          prixFr: "22$",
          prixEn: "$22",
          descFr: "2 œufs pochés biologique, fromage manchego et du persil sur un pan con tomato (pain toasté à l'ail, tomates et huile d'olive) servi avec 2 tranche de bacon de boeuf.",
          descEn: "2 organic poached eggs, Manchego cheese, and parsley on pan con tomate (toasted bread with garlic, tomatoes, and olive oil), served with 2 slices of beef bacon."
        },
        {
          fr: "Française",
          en: "French",
          prixFr: "24$",
          prixEn: "$24",
          descFr: "2 œufs pochés biologiques, croissant tartiné au fromage de chèvre avec un confit de canard effiloché, servi avec des légumes et des patates maison.",
          descEn: "2 organic poached eggs, a croissant spread with goat cheese and topped with shredded duck confit, served with vegetables and homemade potatoes."
        }
        ,
        {
          fr: "Maghrebine",
          en: "Maghreb",
          prixFr: "21$",
          prixEn: "$21",
          descFr: "2 œufs pochés biologique, 2 tranches de pain traditionnel maghrébin, 2 merguez et un flan de pois chiche (karantika) accompagné de légumes griller.",
          descEn: "2 organic poached eggs, 2 slices of traditional Maghreb bread, 2 merguez sausages, and a chickpea flan (karantika) accompanied by grilled vegetables."
        }
      ], "Servi avec salade et patate maison", "Served with salad and homemade potatoes")}

      {renderMenuSection("OMELETTES", "OMELETS", [
        {
          fr: "Omelette Méditerranéenne",
          en: "Mediterranean Omelet",
          prixFr: "19$",
          prixEn: "$19",
          descFr: "Omelette aux saveurs méditerranéennes, garnie de tomates juteuses, d’oignons, de fromage feta et d’olives.",
          descEn: "Omelet with Mediterranean flavors, filled with juicy tomatoes, onions, feta cheese, and olives."
        },
        {
          fr: "Omelette aux truffes",
          en: "Truffle Omelet",
          prixFr: "20$",
          prixEn: "$20",
          descFr: "Omelette onctueuse parfumée aux truffes fraîches.",
          descEn: "Creamy omelet infused with fresh truffles, for an exquisite flavor experience."
        },
        {
          fr: "Tortilla espagnola",
          en: "Spanish Tortilla",
          prixFr: "18$",
          prixEn: "$18",
          descFr: "Tortilla espagnole traditionnelle avec œufs, pommes de terre, oignons et persil, avec option piquante selon votre préférence.",
          descEn: "Traditional Spanish tortilla with eggs, potatoes, onions, and parsley, with the option of adding spice to your liking."
        }
      ])}
    </div>
  );
};

const MenuListItem = ({ fr, en, prixFr, prixEn, descFr, descEn, language }: any) => (
  <li className="border-b border-gray-200 pb-6 last:border-0">
    <div className="flex justify-between items-start">
      <div>
        <h3 className="font-bold text-xl">{language === "fr" ? fr : en}</h3>
        <p className="text-gray-600 mt-1 text-sm">{language === "fr" ? descFr : descEn}</p>
      </div>
      <span className="text-green-950 font-medium text-lg whitespace-nowrap ml-4">
        {language === "fr" ? prixFr : prixEn}
      </span>
    </div>
  </li>
);

export default Main;
